// Pure helpers shared by the projector page and the control-page previews,
// so both always render a theme identically.

export const GRADIENTS = [
  { id: 'midnight', name: 'Midnight', css: 'linear-gradient(135deg, #0f172a, #1e3a8a)' },
  { id: 'ocean', name: 'Ocean', css: 'linear-gradient(135deg, #0c4a6e, #0891b2)' },
  { id: 'forest', name: 'Forest', css: 'linear-gradient(135deg, #052e16, #15803d)' },
  { id: 'royal', name: 'Royal', css: 'linear-gradient(135deg, #2e1065, #7e22ce)' },
  { id: 'sunrise', name: 'Sunrise', css: 'linear-gradient(135deg, #7c2d12, #f59e0b)' },
  { id: 'ember', name: 'Ember', css: 'linear-gradient(135deg, #450a0a, #dc2626)' },
  { id: 'charcoal', name: 'Charcoal', css: 'linear-gradient(135deg, #0a0a0a, #404040)' },
];

export const DEFAULT_BACKGROUND = { type: 'color', gradientId: 'midnight', imageId: null, dim: 0.35 };
export const DEFAULT_TEXT_EFFECT = { shadow: 0, outline: false };

/**
 * Style for the background layer plus the dim overlay opacity.
 * `color` is the solid fallback (also used when an image is missing).
 */
export function backgroundCss(background, color = '#000000', imageUrl = null) {
  const bg = { ...DEFAULT_BACKGROUND, ...background };
  if (bg.type === 'gradient') {
    const g = GRADIENTS.find(x => x.id === bg.gradientId) || GRADIENTS[0];
    return { style: { background: g.css }, dim: 0 };
  }
  if (bg.type === 'image' && imageUrl) {
    const dim = Math.min(0.8, Math.max(0, Number(bg.dim) || 0));
    return {
      style: { backgroundColor: color, backgroundImage: `url("${imageUrl}")`, backgroundSize: 'cover', backgroundPosition: 'center' },
      dim,
    };
  }
  return { style: { background: color }, dim: 0 };
}

const SHADOWS = [
  null,
  '0 2px 4px rgba(0,0,0,0.6)',
  '0 2px 8px rgba(0,0,0,0.85), 0 0 2px rgba(0,0,0,0.9)',
  '0 3px 12px #000, 0 0 6px #000, 0 0 3px #000',
];
const OUTLINE = [[-2, 0], [2, 0], [0, -2], [0, 2], [-2, -2], [2, -2], [-2, 2], [2, 2]]
  .map(([x, y]) => `${x}px ${y}px 0 #000`).join(', ');

/** `text-shadow` style for readable text; empty object when no effect is on. */
export function textEffectCss(textEffect) {
  const fx = { ...DEFAULT_TEXT_EFFECT, ...textEffect };
  const level = Math.min(3, Math.max(0, Math.round(Number(fx.shadow) || 0)));
  const parts = [SHADOWS[level], fx.outline ? OUTLINE : null].filter(Boolean);
  return parts.length ? { textShadow: parts.join(', ') } : {};
}
